var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import Icon from "../Icon";
var Svg = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var Graph = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "#E2665C" : _b, _c = _a.width, width = _c === void 0 ? 24 : _c, _d = _a.height, height = _d === void 0 ? 24 : _d, className = _a.className;
    return (React.createElement("div", { style: { width: width, height: height }, className: className },
        React.createElement(Svg, { viewBox: "0 0 24 24 " },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4142 6.99997L12.0742 13.34L9.57417 11.34L5.70706 15.2071L4.29285 13.7929L9.42574 8.65997L11.9257 10.66L17 5.58575L18.4142 6.99997Z", fill: color }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 18H18.5V20H4V18Z", fill: color }),
            React.createElement("rect", { x: "18.8706", y: "7.00012", width: "7", height: "2", transform: "rotate(180 18.8706 7.00012)", fill: color }),
            React.createElement("rect", { x: "16.875", y: "12", width: "7", height: "2", transform: "rotate(-90 16.875 12)", fill: color }))));
};
var templateObject_1;
